// src/components/QuoteForm.js
import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser'; // 1. Importer EmailJS

const QuoteForm = () => {
    const form = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [charCount, setCharCount] = useState(0);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitSuccess(false);
        setErrorMessage('');

        const YOUR_SERVICE_ID = "service_nankl0p";
        const YOUR_TEMPLATE_ID = "template_rcspxje";
        const YOUR_PUBLIC_KEY = "0YAEFsq3GyfNtv2Kp";

        emailjs.sendForm(YOUR_SERVICE_ID, YOUR_TEMPLATE_ID, form.current, {
            publicKey: YOUR_PUBLIC_KEY,
        })
            .then((result) => {
                console.log('EmailJS Success:', result.text);
                setSubmitSuccess(true);
                if (form.current) form.current.reset();
                setCharCount(0);
            }, (error) => {
                console.error('EmailJS Error:', error);
                const detail = error?.text || error?.message || (typeof error === 'string' ? error : 'Échec de l\'envoi (Vérifiez les autorisations EmailJS ou contactez au 06 92 14 28 03)');
                setErrorMessage(detail);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <section id="devis" className="section">
            <div className="quote-form-container">
                <h2 className="section-title" translate="no">Décrivez-moi votre besoin ou votre projet</h2>
                <p className="form-subtitle">Remplissez ce formulaire et je vous recontacterai dans les meilleurs délais.</p>
                
                {submitSuccess && (
                    <div style={{
                        backgroundColor: '#dcfce7',
                        color: '#15803d',
                        padding: '16px',
                        borderRadius: '10px',
                        marginBottom: '25px',
                        textAlign: 'center',
                        fontWeight: '600',
                        border: '1px solid #86efac'
                    }}>
                        ✅ Merci ! Votre demande a bien été envoyée. Je vous recontacterai dans les meilleurs délais.
                    </div>
                )}

                {errorMessage && (
                    <div style={{
                        backgroundColor: '#fef2f2',
                        color: '#b91c1c',
                        padding: '16px',
                        borderRadius: '10px',
                        marginBottom: '25px',
                        textAlign: 'center',
                        fontWeight: '600',
                        border: '1px solid #fca5a5'
                    }}>
                        ❌ Erreur d'envoi EmailJS : {errorMessage} <br />
                        <span style={{ fontSize: '0.9rem', fontWeight: '400' }}>Vous pouvez aussi appeler directement au <strong>06 92 14 28 03</strong>.</span>
                    </div>
                )}

                <form ref={form} onSubmit={handleSubmit}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label htmlFor="nom">Nom *</label>
                            <input type="text" id="nom" name="nom" placeholder="Votre nom" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="prenom">Prénom *</label>
                            <input type="text" id="prenom" name="prenom" placeholder="Votre prénom" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="telephone">Téléphone *</label>
                            <input type="tel" id="telephone" name="telephone" placeholder="0692 XX XX XX" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">E-mail *</label>
                            <input type="email" id="email" name="email" placeholder="votre@email.com" required />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="service">Type de service *</label>
                        <select id="service" name="service" required>
                            <option value="">Sélectionnez un service</option>
                            <option value="depannage">Dépannage Électrique</option>
                            <option value="installation-renovation">Installation & Rénovation</option>
                            <option value="domotique">Domotique</option>
                            <option value="multiservices">Multiservices</option>
                            <option value="autre">Autre</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="demande">Votre demande *</label>
                        <textarea 
                            id="demande" 
                            name="demande" 
                            rows="6" 
                            placeholder="Décrivez votre projet en détail : type de travaux, surface, délais souhaités, etc." 
                            maxLength="500"
                            onChange={(e) => setCharCount(e.target.value.length)}
                            required
                        ></textarea>
                        <div className="char-counter">{charCount} / 500 caractères</div>
                    </div>
                    
                    {/* Le bouton est maintenant désactivé pendant l'envoi */}
                    <button type="submit" className="submit-btn" disabled={isSubmitting}>
                        {isSubmitting ? 'Envoi en cours...' : 'Envoyer ma demande'}
                    </button>
                </form>
            </div>
        </section>
    );
};

export default QuoteForm;